export const ageCertifications = {
  'G': "Tous publics",
  'PG': "- 10 ans",
  'PG-13': "- 12 ans",
  'R': "- 16 ans",
  'NC-17': "- 18 ans",
};
